import React from 'react';

/**
 * Reusable authentication illustration component for auth pages
 * @param {Object} props
 * @param {string} props.title - The main heading text
 * @param {string} props.description - The description text below the title
 * @param {string} props.variant - Background variant: 'default' | 'success'
 * @returns {JSX.Element} AuthIllustration component
 */
const AuthIllustration = ({ title, description, variant = 'default' }) => {
  const gradientClasses =
    variant === 'success'
      ? 'bg-gradient-to-br from-green-500 via-green-600 to-green-700'
      : 'bg-gradient-to-br from-primary-600 via-primary-700 to-primary-800';

  return (
    <div
      className={`hidden lg:flex lg:w-1/2 ${gradientClasses} relative overflow-hidden`}
    >
      <div className="relative z-10 flex flex-col justify-center items-center px-12 text-white">
        <div
          className={`w-full max-w-md ${variant === 'success' ? 'text-center' : ''}`}
        >
          <div className="mb-8">
            <img
              src="/logo.png"
              alt="Integrable Logo"
              className="h-24 w-auto object-contain"
            />
          </div>
          <h1 className="text-4xl font-bold mb-4">{title}</h1>
          <p
            className={`text-xl mb-8 ${
              variant === 'success' ? 'text-green-100' : 'text-primary-100'
            }`}
          >
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthIllustration;
